module.exports = __webpack_public_path__ + "media/assets/icon-globe-dark-a53873e9906288506bcbe8bb7801f93e.svg";